import { useState, useCallback, useMemo } from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { useGetVehicleStockListQuery } from '../../../../api/endpoints/vehicleOrder';

const initialFilters = {
    chassisNo: '',
    brand: '',
    model: '',
    matnr: '',
    maktx: '',
    sellable: null
};

const useMyVehicleStock = () => {
    const { th, getCurrentLanguageId } = useLanguage();
    const languageId = getCurrentLanguageId();
    const [filters, setFilters] = useState(initialFilters);

    const queryArg = useMemo(() => ({ ...filters, languageId }), [filters, languageId]);

    const { data = [], isFetching, refetch: rtqRefetch } = useGetVehicleStockListQuery(queryArg);

    const handleApplyFilters = useCallback((newFilters) => {
        setFilters(newFilters);
    }, []);

    const handleResetFilters = useCallback(() => {
        setFilters(initialFilters);
    }, []);

    const refetch = useCallback(() => {
        rtqRefetch();
    }, [rtqRefetch]);

    return {
        th,
        data,
        isLoading: isFetching,
        filters,
        handleApplyFilters,
        handleResetFilters,
        refetch
    };
};

export default useMyVehicleStock;
